import actions from '../../actionTypes';

export default user => {
  return {
    type: actions.ADDED_USER,
    user
  };
};



// WEBPACK FOOTER //
// ./src/reducers/users/actions/addedUser.js